var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile__container--wrapper profile__container--columns-2"},[_c('candidate-dossier-records',{attrs:{"addWrapperClasss":"profile__container--columnPos-1","intial-records":_vm.conflictingRecords}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }